import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { wait } from '../../../../../submodules/common/util';
import { RestErrorManager } from '../../angular-common/errors/rest-error-manager';
import { BaseView } from '../base-view';
import { GridColumn } from '../grids/grid-column';
import { NotificationDataService } from '../notification-data.service';
import { FormFieldState } from './form-field/data/form-field-state';
import { FormFieldDataService } from './form-field/form-field-data.service';
import { FormFieldComponent } from './form-field/form-field.component';
import { FormSettings } from './form-settings';

@Component({ template: '' })
export abstract class FormComponent extends BaseView {

  /**
   * True se il form è in fase di caricamento
   */
  formLoading: boolean = true;

  /**
   * True se il form è in fase di invio
   */
  formSubmitting: boolean;

  /** 
   * @valueForInput 
   * Questo attributo deve essere usato come input per i formField
   */
  valuesForInput: {[key: string]: number | string | boolean | (string |number)[] | File | File[]} = {};

  /** I valori di partenza dei campi del form. Questo modello deve essere usato
   *  per inizializzare 'input'
   */
  originalValues: {[key: string]: number | string | boolean | (string |number)[] | File | File[]} = {};

  /** I valori correnti dei campi del form. Questo modello deve raccogliere ogni valore
   *  emesso dai form field e deve essere ribaltato sull'input del POST/PUT al momento
   *  della submit
   */
  currentValues: {[key: string]: number | string | boolean | (string |number)[] | File | File[]} = {};

  /** true se candidate è diverso da original, false in caso contrario
   */
  modified: boolean = false;

  /** true se almeno uno dei campi ha un errore di validazione
   */
  someErrors: boolean = false;

  /**
   * Messaggio di errore (già internazionalizzato ???)
   */
  interFieldsError: string;

  /**
   * @valueForInput
   * I settings del form
   */
   _settings: FormSettings = {fieldsSettings: {}}
   set settings(settings: FormSettings) {
     if(settings)
      this._settings = settings
   }
   get settings(){
     return this._settings
   }

  currentFormState: {[key: string]: FormFieldState} = {};

  /**
   * @valueForInput
   * Proprietà del form (al momento solo dei singoli campi del form) che possono essere modificati durante il 
   * ciclo di vita del form: 
   * es. editMode, readOnly, toBeValidated, required, ecc.
   */
  specifiedAttributes: {[key: string]: {[key: string]: any}} = {}

  //TODO: il prefisso set è ambiguo: meglio datasourceSet (datasource settato) ??
  setDatasourceCompleted: boolean;

  constructor(protected _injector: Injector) { 
    super(_injector)
  }

  /**
   * Viene chiamato quando il form è un componente slave, quindi riceve i dati in input da un componente master
   */
  _input: any;
  @Input()
  set input(_input) {
    console.log('%clifecycle - FormComponent.set input()'+JSON.stringify(_input), 'color: red;');
    this._input = _input;
    this._manageInputHook();
  }
  get input() {return this._input}
  protected /*abstract*/ async _manageInputHook(){}

  @Output()
  output: EventEmitter<any> = new EventEmitter<any>();
  protected /*abstract*/ async _manageOutputHook(){}

  @Output()
  exit: EventEmitter<any> = new EventEmitter<any>();
  protected /*abstract*/ async _manageExitHook(){}

  /** @templateMethod */
  async init() {
    console.log('%clifecycle - FormComponent.init()', 'color: red;');
    console.log('%clifecycle - FormComponent.init() - updateLoading(true)', 'color: red;');
    this.setDatasourceCompleted=false;
    this.changeDatasourceCompleted(false);
    this.formLoading=true;
    this.formSubmitting=false;

    console.log('%clifecycle - FormComponent.init() - 1: initFields START', 'color: red;');
    //await this.initFields() //Predisposto per essere uniforme con griglia. Al momento non fa nulla
    console.log('%clifecycle - FormComponent.init() - 1: initFields END', 'color: red;');

    console.log('%clifecycle - FormComponent.init() - 2: initSettings START', 'color: red;');
    await this.initSettings()
    console.log('%clifecycle - FormComponent.init() - 2: initSettings END', 'color: red;');

    console.log('%clifecycle - FormComponent.init() - 3: setDatasource START', 'color: red;');
    await this.setDatasource()
    console.log('%clifecycle - FormComponent.init() - 3: setDatasource END', 'color: red;');
  }

  /** @templateMethod */
  async initSettings() {
    this._settings = await this._initSettingsHook();
  }
  protected abstract async _initSettingsHook(): Promise<FormSettings>;

  /** @templateMethod */
  async initFields() {
    //this.columns = await this._initFieldsHook()
  }
  protected /*abstract*/ async _initFieldsHook(): Promise<GridColumn/*TODO*/>{return null}

  /**
   * @templateMethod
   * Deve contenere la logica per popolare original 
   * (e input inizializzato come original) a partire dai dto
   * di progetto
   */
  async setDatasource(): Promise<void | 'VALIDATION_ERROR' | 'JUICE_SERVER_ERROR'| 'GENERIC_ERROR'> {
    console.log('%clifecycle - FormComponent.setDatasource()', 'color: red;');
    try {
        this.valuesForInput = await this._setDatasourceHook()
        //non si può clonare il valuesForInput a partire da originalValues perchè si perderebbero gli objects (campi di tipo File)
        this.originalValues = JSON.parse(JSON.stringify(this.valuesForInput))
        //this.updateLoading(false); //TODO: capire cosa fare 
    } catch (error) {
        return this._injector.get(RestErrorManager).manageError(error);
    }
    this.formLoading=false;
    this.setDatasourceCompleted=true;
    this.changeDatasourceCompleted(true);
  }
  protected abstract async _setDatasourceHook(): Promise<{[key: string]: number | string | boolean | (string |number)[] | File | File[] }>;

  /** @templateMethod 
   * successMessage messaggio da mostrare a video (già internazionalizzato) in caso di submit avvenuto con successo 
  */
  async submit(successMessage?:string): Promise<void | 'VALIDATION_ERROR' | 'JUICE_SERVER_ERROR'| 'GENERIC_ERROR'> {
    console.log('%clifecycle - FormComponent.submit()', 'color: red;');
    let err;
    this.formSubmitting = true;
    this.setReadOnly()
    //Nel caso non sia ancora scattata la validazione, la attiva prima che possano essere inviati al server dati non validi
    this.activateValidation()
    await wait(500) //deve aspettare il tempo utile affinchè venga attivata la validazione
    if(this.someErrors) {
      this.removeReadOnly()
      this.formSubmitting = false;
      return 'VALIDATION_ERROR';
    }
    
    try {
      await this._submitHook()
      if(successMessage)
        this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant(successMessage));
      this._manageOutputHook();
      this.output.emit(this.currentValues)
    } catch (error) {
      err = this._injector.get(RestErrorManager).manageError(error);
    }finally{
      this.removeReadOnly()
      this.formSubmitting = false;
    }
    if(err)
      return err
  }
  protected abstract async _submitHook(); //TODO restituire il codice del messaggio (ed eventuali parametri) da mostrare nella snackbar in caso di successo
 
  async cancel() {
    console.log('%clifecycle - FormComponent.cancel()', 'color: red;');
    await this._cancelHook();
    this.exit.emit()
  }
  protected /*abstract*/ async _cancelHook() {};

  public initSettingsModel = () => {
    Object.keys(this).filter(el=>this[el] instanceof FormFieldComponent).forEach(el => {
      this.currentFormState[el.split('FormField').join('')]={}
    });
  }

/** 
   * @templateMethod
   * Viene invocato a fronte di un evento modelChange per modificare il model
   * del form in accordo con il nuovo valore assunto dallo specifico field
   * @param fieldId l'id del field da aggiornare
   * @param event l'event, contenente il valore da utilizzare per effettuare l'aggiornamento (in event.value)
   * @param index solo nel caso di form dinamici, l'indice dell'elemento da aggiornare
   */
  async updateCurrentValue(fieldId: string, event: any, index?: number) {
    console.log(`%clifecycle - FormComponent.updateCurrentValue() - ${fieldId}${[undefined,null].includes(index)?'':'['+index+']'}: ${event.value}`, 'color: red;');
    this.currentFormState[fieldId]=event;
    if(![undefined,null].includes(index)){
      if([undefined,null].includes(this.currentValues[fieldId])){
        this.currentValues[fieldId]=[]
      }
      this.currentValues[fieldId][index] = event.value;
    } else {
      this.currentValues[fieldId] = event.value;
    }
   
    this.modified = JSON.stringify(this.originalValues)!=JSON.stringify(this.currentValues)

    this.interFieldsError = null;
    let someErrors:boolean = Object.keys(this.currentFormState).some(el=>this.currentFormState[el].error);

    //TODO: da spostare. non può essere fatto qui perchè si passa N volte (1 per form field)
    // if(!someErrors){
    //    const error:{[key: string ]: string } = await this._doValidation();

    //    if(error){
    //      if(error.hasOwnProperty("INTER_FIELDS")){
    //       this.interFieldsError = error["INTER_FIELDS"]
    //      }else{
    //        //TODO: settare errore su singolo formField (non set Error ma prevedere un setSpecifiedAttribute)
    //      }
    //       someErrors = true;
    //    }
    // }

    this.someErrors = someErrors;
  }

  /** 
   * @templateMethod
   * @param fieldId l'id del dynamicField a cui aggiungere un elemento
   */
    async addValueToDynamicFormField(fieldId: string) {
    console.log(`%clifecycle - FormComponent.addValueToDynamicFormField() - ${fieldId}`, 'color: red;');
    (this.valuesForInput[fieldId] as string[]).push('')
    
    this.modified = JSON.stringify(this.originalValues)!=JSON.stringify(this.currentValues)

    this.interFieldsError = null;
    let someErrors:boolean = Object.keys(this.currentFormState).some(el=>this.currentFormState[el].error);

    this.someErrors = someErrors;
  }

  /** 
   * @templateMethod
   * @param fieldId l'id del dynamicField da cui eliminare un elemento
   * @param index l'indice dell'elemento da eliminare
   */
   async deleteValueFromDynamicFormField(fieldId: string, index: number) {
    console.log(`%clifecycle - FormComponent.deleteValueFromDynamicFormField() - ${fieldId}${'['+index+']'}`, 'color: red;');
    this.valuesForInput[fieldId] = (this.valuesForInput[fieldId] as any[]).filter((el,i)=>i!=index)
    this.currentValues[fieldId] = (this.currentValues[fieldId] as any[]).filter((el,i)=>i!=index)
    this.valuesForInput[fieldId] = [undefined, null].includes(this.currentValues[fieldId])
                                   ? this.currentValues[fieldId]
                                   : JSON.parse(JSON.stringify(this.currentValues[fieldId]))
   
    this.modified = JSON.stringify(this.originalValues)!=JSON.stringify(this.currentValues)

    this.interFieldsError = null;
    let someErrors:boolean = Object.keys(this.currentFormState).some(el=>this.currentFormState[el].error);

    this.someErrors = someErrors;
  }

  /**
   * Svuota un form field, agendo su input model.
   * NOTA: per come funziona l'input di un angular component questo espediente è necessario per far recepire il cambiamento
   */
  public cleanField = (fieldId: string, index?: number) => {
    console.log('fieldId :>> ', fieldId);
    console.log('index :>> ', index);
    if([undefined,null].includes(index)){
      console.log(`%clifecycle - FormComponent.cleanField() - ${fieldId}`, 'color: red;');
      this.valuesForInput[fieldId]='CLEANING AT '+new Date().toISOString()
    }
    else {
      console.log(`%clifecycle - FormComponent.cleanField() - ${fieldId}${'['+index+']'}`, 'color: red;');
      this.valuesForInput[fieldId][index]='CLEANING AT '+new Date().toISOString()
    }
  }

  /**
   * Pulisce tutti i campi del form
   */
  public clearForm() {
    Object.keys(this.settings.fieldsSettings).forEach(el=>this.cleanField(el))
  }
  /**
   * Riporta tutti i campi del form ai valori iniziali
   */
  public resetForm() {
    this.clearForm()
    this._injector.get(ChangeDetectorRef).detectChanges()
    this.valuesForInput=JSON.parse(JSON.stringify(this.originalValues))
  }

  /**
   * Mette l'intero form in modalità ReadOnly
   */
  setReadOnly() {
    //console.log('setReadOnly this.currentValues:>> ', this.currentValues);
    Object.keys(this.settings.fieldsSettings).forEach(fieldId => {
      //console.log('setReadOnly fieldId:>> ', fieldId);
      this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {readOnly: true}
      this._injector.get(ChangeDetectorRef).detectChanges();
    });
  }
  /**
   * Toglie dall'intero form la modalità ReadOnly
   */
  removeReadOnly() {
    Object.keys(this.settings.fieldsSettings).forEach(fieldId => {
      this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {readOnly: false}
      this._injector.get(ChangeDetectorRef).detectChanges();
    });
  }

  /**
   * Attiva la validazione per l'intero form
   */
  activateValidation() {
    Object.keys(this.settings.fieldsSettings).forEach(fieldId => {
      this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {toBeValidated: true}
      this._injector.get(ChangeDetectorRef).detectChanges();
    });
  }
  /**
   * Disattiva la validazione per l'intero form
   */
  deactivateValidation() {
    Object.keys(this.settings.fieldsSettings).forEach(fieldId => {
      this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {toBeValidated: false}
      this._injector.get(ChangeDetectorRef).detectChanges(); 
    });
  }
  /**
   * ...
   */
  changeDatasourceCompleted(value: boolean) {
    Object.keys(this.settings.fieldsSettings).forEach(fieldId => {
      this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {setDatasourceCompleted: value}
      this._injector.get(ChangeDetectorRef).detectChanges(); 
    });
  }

  protected async _doValidation(): Promise<{[key: string ]: string }>{
    return null;
  }

  markAsReadOnly(fieldId) {
    this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {readOnly: true}
      this._injector.get(ChangeDetectorRef).detectChanges();
  }
  unmarkAsReadOnly(fieldId) {
    this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {readOnly: false}
      this._injector.get(ChangeDetectorRef).detectChanges();
  }

  markAsRequired(fieldId) {
    this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {required: true}
      this._injector.get(ChangeDetectorRef).detectChanges();
  }
  unmarkAsRequired(fieldId) {
    this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {required: false}
      this._injector.get(ChangeDetectorRef).detectChanges();
  }

  hide(fieldId) {
    this._injector.get(ChangeDetectorRef).detectChanges();
    this.specifiedAttributes[fieldId] = {hidden: true}
    this._injector.get(ChangeDetectorRef).detectChanges();
  }
  show(fieldId) {
    this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {hidden: false}
      this._injector.get(ChangeDetectorRef).detectChanges();
  }

  focus(fieldId) {
    this._injector.get(ChangeDetectorRef).detectChanges();
    this.specifiedAttributes[fieldId] = {editMode: true}
    this._injector.get(ChangeDetectorRef).detectChanges();
  }
  unfocus(fieldId) {
    this._injector.get(ChangeDetectorRef).detectChanges();
      this.specifiedAttributes[fieldId] = {editMode: false}
      this._injector.get(ChangeDetectorRef).detectChanges();
  } 

}
